/** OrderDesk "Emailed" folders — same portal rules (driven by `Emailed For` metadata). */
export const EMAILED_FOLDERS = [399369, 435736, 435738] as const

export type EmailedFolderId = (typeof EMAILED_FOLDERS)[number]

/** Folders where Cancel Order must be disabled (Proofs Pending, Canceled, etc.). */
export const CANCEL_DISABLED_FOLDERS = [399346, 399366, 435736] as const

export function isEmailedFolder(
  folderId: string | number | null | undefined,
): boolean {
  if (folderId == null || folderId === '') return false
  const id = Number(folderId)
  return EMAILED_FOLDERS.some(f => f === id)
}

export function isCancelOrderDisabled(
  folderId: string | number | null | undefined,
): boolean {
  if (folderId == null || folderId === '') return false
  const id = Number(folderId)
  return CANCEL_DISABLED_FOLDERS.some(f => f === id)
}
